module.exports = __webpack_public_path__ + "media/images/icon_video-900e5a5997a0d87a054335de4e65c1de.png";